module.exports = __webpack_public_path__ + "assets/img/4.6b35d2f4.jpg";